import { SectionTitle } from "./SectionTitle";
import { useTranslation } from "@/lib/i18n";

export const CanvasPreviewSection = () => {
  const t = useTranslation();

  return (
    <div className="p-4">
      <SectionTitle title={t.sections.stickerPreview} />

      <div
        id="canvas-container"
        className="relative w-full aspect-square overflow-hidden rounded-md bg-muted"
      />
      <p className="mt-2 text-xs text-muted-foreground text-center">
        {t.canvasPreview.desc}
      </p>
    </div>
  );
};

CanvasPreviewSection.displayName = "CanvasPreviewSection";
